// Routes del módulo lead-magnets. Mapa de tabs:
//   /m/lead-magnets/list      → CRUD list + selección + sub-tabs
//   /m/lead-magnets/create    → form de creación
//
// El sidebar (registry.tsx) declara los tabs.

import { useState } from 'react';

import { LandingPreview } from './components/LandingPreview';
import { LeadMagnetForm } from './components/LeadMagnetForm';
import { LeadMagnetList } from './components/LeadMagnetList';
import { SequenceBuilder } from './components/SequenceBuilder';
import { SubscriberTable } from './components/SubscriberTable';
import type { LeadMagnet } from './types';

type SubTab = 'subscribers' | 'sequence' | 'preview';

export function LeadMagnetsListView() {
  const [selected, setSelected] = useState<LeadMagnet | null>(null);
  const [subTab, setSubTab] = useState<SubTab>('subscribers');

  return (
    <div className="space-y-4 p-4">
      <h1 className="text-xl font-semibold">Lead Magnets</h1>
      <p className="text-xs text-muted-foreground">
        Captura email + sequences automatizadas. Los emails capturados se
        propagan al módulo Leads (append-only) con source =
        <span className="font-mono">lead-magnet:&lt;slug&gt;</span>. Org sugerida
        para personal-brand: <span className="font-mono">samuelplata</span>.
      </p>

      <LeadMagnetList
        onSelect={(m) => setSelected(m)}
        selectedId={selected?.id ?? null}
      />

      {selected && (
        <div className="space-y-3 mt-4">
          <div className="flex gap-2 border-b">
            {(['subscribers', 'sequence', 'preview'] as SubTab[]).map((t) => (
              <button
                key={t}
                onClick={() => setSubTab(t)}
                className={
                  'px-3 py-2 text-sm border-b-2 ' +
                  (subTab === t
                    ? 'border-primary font-semibold'
                    : 'border-transparent text-muted-foreground')
                }
              >
                {t === 'subscribers'
                  ? 'Subscribers'
                  : t === 'sequence'
                    ? 'Email sequence'
                    : 'Preview landing'}
              </button>
            ))}
          </div>
          {subTab === 'subscribers' && (
            <SubscriberTable
              magnetId={selected.id}
              magnetSlug={selected.slug}
            />
          )}
          {subTab === 'sequence' && (
            <SequenceBuilder magnetId={selected.id} />
          )}
          {subTab === 'preview' && (
            <LandingPreview
              slug={selected.slug}
              publicUrl={selected.public_url}
            />
          )}
        </div>
      )}
    </div>
  );
}

export function LeadMagnetsCreateView() {
  const [refreshKey, setRefreshKey] = useState(0);
  return (
    <div className="space-y-4 p-4">
      <h1 className="text-xl font-semibold">Crear Lead Magnet</h1>
      <LeadMagnetForm
        key={refreshKey}
        onCreated={() => setRefreshKey((k) => k + 1)}
      />
    </div>
  );
}
